<template>
  <div>
    <!-- DESTINATION ADVICE ACCORDIAN MODAL --> 
    <b-modal
      id="destination-advice-modal"
      ref="destination-advice-modal-ref"
      hide-footer
      title="Destination Advice"
    >
      <div> 
          <DestinationAdviceBody />
      </div>
    </b-modal>
  </div>
</template>
<script>
  import DestinationAdviceBody from '../index.vue'

export default {
  components: {
      DestinationAdviceBody
  },
  data() {
    return {
      dropDown: false,
    }
  },
  methods: {
    toggleExpand() {
      this.dropDown = !this.dropDown;
    },
    showDestinationAdviceModal() {
      this.$refs["destination-advice-modal-ref"].show();
    },
  },
};
</script>

<style lang="scss">
@import "@/modules/booking/itinerary/items/styles.scss";

.expand-collpase-btn {
  color: rgb(33,37,41);
  background-color: #f5f5f5;
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}
.product-main {
  width: 100%;
  color: rgb(33,37,41);
  background-color: #f5f5f5;
  margin: 10px 0;
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-left: 3px solid #76c95f00;
}
.check-in-main {
  width: 100%;
  color: rgb(33,37,41);
  background-color: #f5f5f5;
  margin: 10px 0;
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-left: 3px solid #76c95f00;
}
.toggle-essential {
  cursor: pointer;
  font-size: 30px;
  align-self: center;
}

.mobile-dropdown-item {
  display: block;
}

@media only screen and (min-width: 992px) {
  .product-main {
    display: grid;
    grid-template-columns: 13fr 1fr;
  }
  .check-in-main {
    display: grid;
    grid-template-columns: 13fr 1fr;
  }

  .mobile-dropdown-item {
    display: none;
  }
}


  
</style>
